import React, { useState } from "react";
import logo from "./assets/logo.png";
import { API } from "./Config"; // adjust path if needed

function Signup({ setPage }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [organization, setOrganization] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);

  const container = {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f6fa"
  };

  const card = {
    background: "white",
    padding: 30,
    borderRadius: 10,
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    width: 300,
    textAlign: "center"
  };
  const input = {
    width: "100%",
    padding: 10,
    margin: "10px 0",
    borderRadius: 6,
    border: "1px solid #ccc"
  };
  const button = {
    width: "100%",
    padding: 10,
    background: "#2c3e50",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    marginTop: 10
  };
  const link = {
    color: "#3498db",
    cursor: "pointer",
    fontWeight: "500"
  };

  const handleSignup = () => {
    if (!termsAccepted) {
      alert("Please accept the Terms of Service and Privacy Policy.");
      return;
    }
    const strongPasswordRegex =
     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

    if (!strongPasswordRegex.test(password)) {
      alert(
        "Password must be 8+ chars, include uppercase, lowercase, number & special character"
      );
      return;
    }

    fetch(`${API}/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name,
        email,
        password,
        organization,
        businessType,
        termsAccepted
      })
    })
      .then(res => {
        if (!res.ok) {
          throw new Error("Signup failed");
        }
        return res.json();
      })
      .then(data => {
        if (data.message) {
          alert("Signup successful. Please login.");
          setPage("login");
        } else {
          alert(data.error || "Signup failed");
        }
      })
      .catch(err => {
        console.error("Signup error:", err);
        alert("Something went wrong");
      });
  };

  return (

    <div style={container}>

      <div style={card}>
      <h1 style={{ marginBottom: 10 }}>Mukbi CRM</h1>
      <img
        src={logo}
        alt="Mukbi CRM"
        style={{ width: 120, marginBottom: 10 }}
      />
      <h2>Create Account</h2>

      <input
        placeholder="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        style={input}
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        style={input}
      />
      <div style={{ fontSize: 12, color: "#888", marginBottom: 10 }}>
        Must be 8+ chars with uppercase, number & special character
      </div>
      <input
        placeholder="Your Name"
        value={name}
        onChange={e => setName(e.target.value)}
        style={input}
        />

      <input
        placeholder="Organization (optional)"
        value={organization}
        onChange={e => setOrganization(e.target.value)}
        style={input}
        />

        <input
        placeholder="Business Type (e.g., Manufacturing, Retailer, Real Estate, Hotel)"
        value={businessType}
        onChange={e => setBusinessType(e.target.value)}
        style={input}
        />


        <div style={{ textAlign: "left", fontSize: 12, marginTop: 12 }}>
          <label style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              style={{ marginTop: 3 }}
            />
            <span>
              I agree to the{" "}
              <a
                href="https://www.mukbi.com/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://www.mukbi.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>.
            </span>
          </label>
        </div>


      <button onClick={handleSignup} style={button}
        onMouseOver={(e) => {
            e.target.style.background = "#34495e";
            e.target.style.transform = "scale(1.02)";
          }}
          onMouseOut={(e) => {
            e.target.style.background = "#2c3e50";
            e.target.style.transform = "scale(1)";
          }}>
        Signup
      </button>

      <p>
        Already have an account?{" "}
        <span onClick={() => setPage("login")} style={link}>
          Login
        </span>
      </p>
    </div>
    </div>

  );
}



export default Signup;